import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useMemo } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { breadcrumbMap } from "./breadcrumbMap";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SupportBreadCrumbs() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
    const handleNavigate = (url) => {
        navigate(`/${i18n.language}${url}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    
    }

  
    const crumbs = useMemo(() => {
        const SUPPORTED_LOCALES = ["en", "fr"];
        let segments = location.pathname.split("/").filter(Boolean);

        const locale = SUPPORTED_LOCALES.includes(segments[0])
            ? segments[0]
            : null;

        segments = locale ? segments.slice(1) : segments;


        let currentPath = "";

        const dynamicCrumbs = segments.map((segment, index) => {
            currentPath += `/${segment}`;
            const isLast = index === segments.length - 1;

            const mapper = breadcrumbMap[segment] ?? breadcrumbMap[":id"];
            const label =
                typeof mapper === "function" ? mapper(params) : mapper ?? segment;

            return {
                label,
                path: currentPath,
                isLast,
            };
        });

        return [
            {
                label: "Home",
                path: "/",
                isLast: dynamicCrumbs.length === 0,
            },
            ...dynamicCrumbs.map((crumb, index) => ({
                ...crumb,
                isLast: index === dynamicCrumbs.length - 1,
            })),
        ];
    }, [location.pathname, params]);

  return (
    <Box sx={{mt:{xs:5,md:11.5}}} >
    <Breadcrumbs separator={<ArrowForwardIosIcon sx={{fontSize:'12px',color:'#C9CACC'}}/>} aria-label="breadcrumb">
      {crumbs.map(({ label, path, isLast }) =>
        isLast ? (
          <Typography key={path} sx={{fontWeight:700, fontSize:'12px', color:'#1D2939'}}>
            {label}
          </Typography>
        ) : (
          <Link
          sx={{
            fontWeight:400, fontSize:'12px', color:'#1D2939', cursor:"pointer"
          }}
            key={path}
            onClick={()=>{handleNavigate(path)}}
            underline="hover"
            color="inherit"
          >
            {label}
          </Link>
        )
      )}
    </Breadcrumbs>
    </Box>
  );
}